<template>
    <div id="bene-bank-transfer-container">
        <f7-list form class="form-group" v-if="showFormSet.bankTransfer">
            <f7-list-input
                input-id     ="beneficiaryType"
                id           ="beneficiaryTypeInput"
                name         ="beneficiaryType"
                class        ="clickable-row use-chevron"

                v-if         ="showFormInput.bankTransfer.beneficiaryType"
                :label       ="$t('beneficiary-beneficiary-type')"
                :placeholder ="$t('beneficiary-select-beneficiary-type')"
                :value       ="beneficiaryType"
                @change      ="changeBeneficiaryType($event.target.value);"

                autocomplete ="off"
                outline
                floating-label
            >
                <f7-link popover-open=".popover-dropdown-bene-type" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>

            <f7-popover id="dropdownBeneficiaryType" class="popover-dropdown-bene-type dropdown-default dropdown beneficiary" :backdrop="true">
                <f7-list>
                    <f7-list-item popover-close link="#"
                        @click="changeBeneficiaryType(1);">
                        {{$t('general-text-individual')}}
                    </f7-list-item>
                    <f7-list-item popover-close link="#"
                        @click="changeBeneficiaryType(2);">
                        {{$t('general-text-corporate')}}
                    </f7-list-item>
                </f7-list>
            </f7-popover>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
            this.init()
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'beneficiaryType',
                'beneficiaryTypeId',
            ])
        },
        components: {
        },
        methods: {
            ...mapActions('beneficiary', [
                'setBeneficiaryType'
            ]),

            async init() {
                const self    = this;
                const popover = ".beneficiary.popover-dropdown-bene-type";
                const popoverInner = ".beneficiary.popover-dropdown-bene-type .popover-inner";
                const popoverId = "dropdownBeneficiaryType";
                const inputId = "beneficiaryType";
                const inputListId = "#beneficiaryTypeInput";
                await self.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId)
            },

            changeBeneficiaryType(id) {
                this.$emit("changeBeneficiaryType", id);
            },
        }
    }
</script>